import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from './AuthContext';

/** Sits inside `ProtectedRoute`, wrapping `AppShell` — redirects to
 * `/onboarding` if the authenticated client hasn't completed it yet
 * (CP-P1-T03). */
export function RequireOnboarding(): JSX.Element {
  const { client } = useAuth();
  if (client && !client.onboardingCompletedAt) {
    return <Navigate to="/app/onboarding" replace />;
  }
  return <Outlet />;
}
